module.exports = "<p>\n  impressum works!\n</p>\n"